import {Component} from '@angular/core';
import {ColumnFilter, DataTableColumnData, DataTableConfig, DataTablePaginatedDataSource, TableAction} from '@cas-hub/acabim-common-client';
import {OrganisationPendingUser} from '../../../_models/organisation/organisation-users.model';
import {OrganisationUsersService} from '../../../_services/organisation/organisation-users.service';

@Component({
    selector: 'acabim-admin-organisation-pending-users',
    templateUrl: './organisation-pending-users.component.html',
    styleUrls: ['./organisation-pending-users.component.scss']
})
export class OrganisationPendingUsersComponent extends DataTablePaginatedDataSource<OrganisationPendingUser> {

    public readonly actions: TableAction[] = [];
    public readonly columnData: DataTableColumnData[] = [
        {displayName: 'Email', objectPropertyName: 'inviteeEmail'},
        {displayName: 'Invited Date', objectPropertyName: 'invitedDate'},
        {displayName: 'Invited By', objectPropertyName: 'invitedBy.name'}
    ];

    public readonly columnFilters: ColumnFilter[] = [];

    public readonly config: DataTableConfig = {
        globalFilterFields: [],
        hasActions: false,
        hasCheckbox: false,
        hasDetailsButton: false,
        hasFilters: false,
        isExportEnabled: false,
        isLazyLoadingEnabled: true,
        isPaginationEnabled: true,
        isSearchEnabled: false,
        searchPlaceHolder: '',
        tableHeading: '',
        emptyMessage: 'No pending users found'
    };

    constructor(organisationUsersService: OrganisationUsersService) {
        super((pagination, _) => organisationUsersService.getPendingUsers(pagination));
    }

    public onAction(action: TableAction): void {
    }

    public onDataExpanded(value: OrganisationPendingUser): void {
    }
}
